import { Children, cloneElement, FC, PropsWithChildren } from 'react';
import { InlineFilterColumn } from './components';
import styles from './InlineFiltersGrid.css';

interface IFiltersGridProps {
  columnCount?: number;
}

export const InlineFiltersGrid: FC<PropsWithChildren<IFiltersGridProps>> = ({ children, columnCount = 3 }) => {
  const childrenArray = Children.toArray(children) as JSX.Element[];
  const columns = childrenArray.reduce(
    (acc, item, index) => {
      const i = index % columnCount;

      acc[i].push(item);

      return acc;
    },
    Array.from({ length: columnCount }, (): JSX.Element[] => []),
  );

  return (
    <div className={styles['grid']}>
      {columns.map((column, index: number) => (
        <InlineFilterColumn key={`column_${index}`}>
          {column.map((child, cellIndex) => (
            <div className={styles['cell']} key={cellIndex}>
              {cloneElement(child)}
            </div>
          ))}
        </InlineFilterColumn>
      ))}
    </div>
  );
};
